import { render, staticRenderFns } from "./MainMenuDefault.vue?vue&type=template&id=04ee22ec&lang=pug"
import script from "./MainMenuDefault.vue?vue&type=script&lang=js"
export * from "./MainMenuDefault.vue?vue&type=script&lang=js"
import style0 from "../../../assets/style/default/menu-default.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports